<template>
  <div>
    {{ $t("chapter.infoPopup.content") }}
    <div
      @click="$refs[uploadRef].click()"
      class="file-upload-container rounded pa-1 mb-4"
    >
      <span v-if="filename">{{ filename }} </span
      ><span v-else>{{ $t("chapter.infoPopup.none") }}</span
      ><v-icon right>mdi-folder</v-icon>
    </div>
    <input
      v-show="false"
      :ref="uploadRef"
      hidden
      type="file"
      :accept="formats"
      @change="onFileUpload($event, jwt)"
    />
  </div>
</template>
<script>
import hasMediaObjectUpload from "@/mixins/hasMediaObjectUpload";
import { getFilenameFromMediaUrl, truncateFilenameKeepExtension } from "@/helpers/truncateString"
const FILENAME_MAX_LENGTH = 19
export default {
  mixins: [hasMediaObjectUpload],
  props: {
    mediaSource: String,
    formats: String,
    maxSizeBytes: Number,
  },
  computed: {
    filename() {
      if (this.mediaSource) {
        let filename = getFilenameFromMediaUrl(this.mediaSource);
        return truncateFilenameKeepExtension(filename, FILENAME_MAX_LENGTH);
      }
      return null;
    },
  },
};
</script>
<style scoped>
.file-upload-container {
  background-color: var(--v-accentElementBackground-base);
  cursor: pointer;
  border: 1px solid var(--v-accentElement-base);
}
</style>